<div class="hidden lg:flex flex-1 justify-center items-center">
  <div
    class="bg_color rounded-lg border-2 border_customize_card hover:border_color_customize pl-2 px-1 py-1 flex items-center gap-2 space-x-4 scale-95"
  >
    <!-- Balance Dropdown -->
    <div id="balance-dropdown-container" class="flex justify-center">
      <div id="balance" class="flex items-center space-x-2">
        <div class="pr-2 rounded-lg flex items-center text-2xl gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outlinetext-2x1 text_yellow icon-tabler-poker-chip"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M12 3v4" />
            <path d="M12 17v4" />
            <path d="M3 12h4" />
            <path d="M17 12h4" />
            <path d="M18.364 5.636l-2.828 2.828" />
            <path d="M8.464 15.536l-2.828 2.828" />
            <path d="M5.636 5.636l2.828 2.828" />
            <path d="M15.536 15.536l2.828 2.828" />
          </svg>
          <p class="text-lg font-medium text_white">
            {{ wallet.total | number : "1.2-2" }}
          </p>
        </div>

        <button
          id="balance-dropdown-button"
          class="px-1 pb-1 pt-1 rounded-md bg-transparent text_color_customize hover:text_black button_color_customize hover:button_color_customize shadow-lg"
          (click)="toggleCredits()"
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M6 9l6 6l6 -6" />
          </svg>
        </button>
      </div>

      <div
        id="balance-dropdown"
        [class]="
          showCredits
            ? ' absolute mt-10 w-60 rounded-xl shadow-md text_white z-50 block'
            : ' absolute mt-10 w-60 rounded-xl shadow-md text_white z-50 hidden'
        "
      >
        <div
          class="p-4 space-y-2 card_color rounded-lg border_customize_card border-2"
        >
          <!-- Créditos Section -->
          <div class="pb-3">
            <span class="text_white pb-2 font-bold block">Créditos</span>
            <div
              class="button_color_customize py-3 px-4 rounded-lg flex items-center text-lg gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-2x1 text_yellow icon icon-tabler icons-tabler-outline icon-tabler-poker-chip"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                <path d="M12 3v4" />
                <path d="M12 17v4" />
                <path d="M3 12h4" />
                <path d="M17 12h4" />
                <path d="M18.364 5.636l-2.828 2.828" />
                <path d="M8.464 15.536l-2.828 2.828" />
                <path d="M5.636 5.636l2.828 2.828" />
                <path d="M15.536 15.536l2.828 2.828" />
              </svg>
              {{ wallet.credits | number : "1.2-2" }}
            </div>
          </div>

          <hr class="border-white opacity-20" />

          <!-- Bonos Section -->
          <div>
            <span class="text_white pb-2 font-bold block">Bonos</span>
            <div
              class="button_color_customize py-3 px-4 rounded-lg flex items-center text-lg gap-2 mb-6"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-2x1 text_yellow icon icon-tabler icons-tabler-outline icon-tabler-poker-chip"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                <path d="M12 3v4" />
                <path d="M12 17v4" />
                <path d="M3 12h4" />
                <path d="M17 12h4" />
                <path d="M18.364 5.636l-2.828 2.828" />
                <path d="M8.464 15.536l-2.828 2.828" />
                <path d="M5.636 5.636l2.828 2.828" />
                <path d="M15.536 15.536l2.828 2.828" />
              </svg>
              {{ wallet.bonus | number : "1.2-2" }}
            </div>
          </div>

          <hr class="border-white opacity-20" />

          <!-- Valor de Crédito Section -->
          <span class="text_white pb-2 font-bold block">Valor de Crédito</span>
          <div class="button_color_customize p-2 rounded-lg text_white">
            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
              <span class="text_yellow text-2x1 pt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="text-2x1 text_yellow icon icon-tabler icons-tabler-outline icon-tabler-poker-chip"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                  <path d="M12 3v4" />
                  <path d="M12 17v4" />
                  <path d="M3 12h4" />
                  <path d="M17 12h4" />
                  <path d="M18.364 5.636l-2.828 2.828" />
                  <path d="M8.464 15.536l-2.828 2.828" />
                  <path d="M5.636 5.636l2.828 2.828" />
                  <path d="M15.536 15.536l2.828 2.828" />
                </svg>
              </span>
              <span class="text-2xl text_white">
                1 =
                {{ operator?.data.sellCreditValue | number : "1.2-2" }}
                {{ currencyCode }}
              </span>
            </dd>
          </div>

          <div class="p-1 rounded-lg text_white text-center text-sm mt-1">
            <p>
              Si deseas comprar o retirar créditos, por favor comunícate con
              nosotros.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="flex lg:hidden flex-1 justify-end items-center" *ngIf="isLoggedIn">
  <div
    class="rounded-lg border-2 border_color_customize hover:border-highlight pl-2 px-1 py-1 flex items-center gap-2 space-x-4 scale-95 cursor-pointer"
    (click)="setShowCredits()"
  >
    <!-- Balance -->
    <div id="balance-mobile" class="flex items-center space-x-2">
      <div class="pr-2 rounded-lg flex items-center text-base gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tablertext-2x1 text_yellow -poker-chip"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
          <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
          <path d="M12 3v4" />
          <path d="M12 17v4" />
          <path d="M3 12h4" />
          <path d="M17 12h4" />
          <path d="M18.364 5.636l-2.828 2.828" />
          <path d="M8.464 15.536l-2.828 2.828" />
          <path d="M5.636 5.636l2.828 2.828" />
          <path d="M15.536 15.536l2.828 2.828" />
        </svg>
        <p class="text-lg font-medium text_white">
          {{ wallet.total | number : "1.2-2" }}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- <app-credits-bonos-info
  *ngIf="!isMobile"
  [wallet]="wallet"
  [showCredits]="showCredits"
  (hideModalMyCredits)="hideMycredits()"
></app-credits-bonos-info> -->
